module.exports = __webpack_public_path__ + "static/media/3_col_10.d55ff254.jpg";